// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2h2wn","label":"Section_label__2n83s","contentWrap":"Section_contentWrap__13Wis","footer":"Section_footer__3aslq","footerInner":"Section_footerInner__3WNJF"};